import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import AuthLoginScreen from "../../features/auth/ui/AuthLoginScreen";
import UserCheckedInNotificationScreen from "../../pages/checked-in";
import GuestLayout from "../../widgets/guest-layout";
import { UserData } from "../../features/auth/model/types";
import AuthenticatedRootCheckInApp from "./AuthenticatedRootCheckInApp";

const CheckInAppRoot = ({ userData }: { userData: UserData | null }) => {
  if (!userData) {
    return (
      <Routes>
        <Route
          path="/"
          element={
            <GuestLayout>
              <AuthLoginScreen />
            </GuestLayout>
          }
        />
        <Route
          path="/checked-in"
          element={
            <GuestLayout>
              <UserCheckedInNotificationScreen />
            </GuestLayout>
          }
        />
        <Route path="*" element={<Navigate replace to="/" />} />
      </Routes>
    );
  }

  return <AuthenticatedRootCheckInApp />;
};

export default CheckInAppRoot;
